/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LanguageEnum {
  EnGb = 'EN_GB',
  EnUs = 'EN_US',
  PtBr = 'PT_BR',
  FrFr = 'FR_FR',
  HeIl = 'HE_IL',
  TrTr = 'TR_TR',
  EnTst = 'EN_TST'
}
